export default __webpack_public_path__ + "static/media/tg.f9c60a25.svg";